<script lang="ts">
    import { icon, icon50 } from '@otto-ec/icons';
    import type { OcIconButtonV2Props } from '@otto-ec/otto-components/icon-button';
    import type { Badge } from '@shared/types/types';

    interface Props {
        badges: Badge[] | undefined;
    }

    const { badges }: Props = $props();

    type IconName = keyof typeof icon | keyof typeof icon50;

    function isIconName(value: string): value is IconName {
        return value in icon || value in icon50;
    }

    function iconName(iconClass: Badge['iconClass']): OcIconButtonV2Props['icon'] {
        /*                                                                                              */
        /*                                                                  */
        const name = iconClass.replace('pl_icon_', '');
        return isIconName(name) ? name : 'info';
    }
</script>

{#if badges && badges.length > 0}
    <oc-cinema-v1 class="reptile_sustainabilityBadges" resizing="none" oc-aria-label="Sustainability Badges">
        {#each badges as badge (badge.value)}
            <div class="reptile_sustainabilityBadges__badge">
                <oc-icon-button-v2
                    icon={iconName(badge.iconClass)}
                    oc-aria-label={badge.displayName}
                    variant="inverted-transparent"
                    data-oc-sheet-v1-create
                    data-oc-sheet-v1-create.headline="Was bedeutet dieses Zeichen?"
                    data-oc-sheet-v1-create.base64-url={btoa(badge.explanatoryTextUrl)}
                ></oc-icon-button-v2>
            </div>
        {/each}
    </oc-cinema-v1>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@otto-ec/otto-components-utils/scss/mixins';

    .reptile_sustainabilityBadges {
        width: 100%;
        --gap: #{tokens.$oc-semantic-spacing-25};
        /*                                                                                                     */
        --stage-spacing: 0;
        &__badge {
            background-color: tokens.$oc-semantic-color-sustainable-100;
            border-radius: 50%;
            width: tokens.$oc-base-dimension-32;
            height: tokens.$oc-base-dimension-32;
        }
    }
</style>
